import React from 'react';
import styled from 'styled-components';

import Header from '../components/Header';
import Layout from '../components/Layout';
import Footer from '../components/Footer';

const Contents = styled.div`
  display: block;
  min-height: 50vh;
`;

interface LayoutBlogProps {
  children: React.ReactNode;
  ssrLang?: string;
  home?: boolean;
}

const LayoutBlog: React.FC<LayoutBlogProps> = ({ children, ssrLang, home }) => (
  <Layout ssrLang={ssrLang}>
    <>
      <Header home={home} />
      <main>
        <Contents>{children}</Contents>
      </main>
      <Footer />
    </>
  </Layout>
);

export default LayoutBlog;
